import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { getOperators } from './CellFormatingHelper';
import { useTranslation } from 'react-i18next';

const Operators = ({ attributeType, operator, onOperatorChange }) => {

    const { t } = useTranslation([
        "attribute/cell_formatting"
    ]);

    const operators = getOperators(attributeType);

    const traslatedOperators = operators.map(operator => {
        return { text: t("operators." + operator.trim().toLowerCase().replace(/ /g, "_")), value: operator };
    });

    function getOperatorValue() {
        if (typeof operator === "object") {
            return {
                text: t("operators." + operator.value.trim().toLowerCase().replace(/ /g, "_")),
                value: operator.value
            };
        }
        return {
            text: t("operators." + operator.trim().toLowerCase().replace(/ /g, "_")),
            value: operator
        };
    }

    return (
        <div className={`col-${getOperatorValue().value === "Greater than or equal to" || getOperatorValue().value === "Less than or equal to" ? "6" : "4"}`}>
            <DropDownList
                data={traslatedOperators}
                value={getOperatorValue()}
                textField="text"
                onChange={(e) => onOperatorChange(e.target.value)}
            />
        </div>
    );
};

export default Operators;